export default "__VITE_ASSET__BSIwFhah__"